export const VUE_APP_API_URL = (window as any).VUE_APP_API_URL || process.env.VUE_APP_API_URL;
export const VUE_APP_API_KEY = (window as any).VUE_APP_API_KEY || process.env.VUE_APP_API_KEY;
export const VUE_APP_COUNTRIES = (window as any).VUE_APP_COUNTRIES || process.env.VUE_APP_COUNTRIES;
export const VUE_APP_BRANDING = (window as any).VUE_APP_BRANDING || process.env.VUE_APP_BRANDING;
export const VUE_APP_ENV = (window as any).VUE_APP_ENV || process.env.VUE_APP_ENV;